<div class="progress-bar">
  <div class="track">
    <div class="label">{{ label }}</div>
    <div
      class="bar-indicator"
      [style.width]="progress + '%'"
    ></div>
    <div
      class="bar-indicator used"
      [style.width]="progress2 + '%'"
    ></div>
  </div>
</div>
